import { t } from 'i18next';

export const FOOTNOTE_SYMBOL = '*';
export const HARDCODED_CL_FEE_MIN = 11000;
export const TIME_CICLE_ANIMATION = 1000;

export const translationValuesMinimumAmount = {
  addMoreProducts: t('CheckoutOrderDetail:addMoreProducts'),
  changeToPickup: t('CheckoutOrderDetail:changeToPickup')
};

export const ORDER_DETAIL_ITEMS_ID = {
  SUBTOTAL: 'subtotal',
  PAPA_POINTS_BENEFITS: 'papaPointsBenefits',
  TAX: 'tax',
  DELIVERY: 'delivery',
  MIN_DELIVERY_FEE_TEXT: 'minDeliveryFeeText',
  TOTAL_SAVED: 'totalSaved',
  SEPARATOR: 'separator',
  TIP: 'tip',
  MINIMUM_DELIVERY: 'minimumValueForDelivery',
  TIP_SELECTION: 'tipSelection',
  PAPA_POINTS_USED: 'papaPointsUsed'
};
